import { UIEventSource } from "../../UIEventSource"
import FilteredLayer from "../../../Models/FilteredLayer"
import { FeatureSourceForLayer } from "../FeatureSource"
import { Feature, Geometry } from "geojson"
import { OsmTags } from "../../../Models/OsmFeature"

export default class SimpleFeatureSource<T extends Feature = Feature<Geometry, OsmTags>>
    implements FeatureSourceForLayer<T>
{
    public readonly features: UIEventSource<T[]>
    public readonly layer: FilteredLayer

    constructor(layer: FilteredLayer, featureSource?: UIEventSource<T[]>) {
        this.layer = layer
        this.features = featureSource ?? new UIEventSource<T[]>([])
    }
}
